import { ApiServices } from "../../services/api_services";
import { CORESERVICE_URL } from "../../constants/api_constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const initialUserSetup = createAsyncThunk(
  "user/initial_setup_status",
  async (email: any, thunkApi) => {
    return ApiServices.get(CORESERVICE_URL, "/initial_setup_status")
      .then((response) => response)
      .catch((error) => error);
  }
);
